<template>
    <div class="progress">
        <div class="progress-bar" :style="{ width: value + '%', backgroundColor }" :class="progressClasses"></div>
    </div>
</template>

<script>
    export default {
        props: {
            value: {type: Number, default: 0},
            color: {default: '#0374d7'}, // primary color
            type: {default: null},
            progressClass: {default: null},
            animated: {default: false},
            animatedClass: {default: 'progress-bar-striped progress-bar-animated'},
        },

        computed: {
            backgroundColor() {
                return this.progressClass || this.type ? '' : this.color;
            },
            progressClasses() {
                let clazz = this.progressClass || '';
                clazz += this.animated ? this.animatedClass : '';
                clazz += this.type ? ` bg-${this.type}` : '';
                return clazz;
            },
        }
    };
</script>
